const Client = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 14 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.3383 12.5973V14.0793C13.3383 14.5239 13.0419 14.8203 12.5973 14.8203C12.1527 14.8203 11.8563 14.5239 11.8563 14.0793V12.5973C11.8563 11.3376 10.8929 10.3742 9.63321 10.3742H3.70508C2.44535 10.3742 1.48203 11.3376 1.48203 12.5973V14.0793C1.48203 14.5239 1.18563 14.8203 0.741017 14.8203C0.296407 14.8203 0 14.5239 0 14.0793V12.5973C0 10.5224 1.63024 8.8922 3.70508 8.8922H9.63321C11.7081 8.8922 13.3383 10.5224 13.3383 12.5973Z"
      fill="#546E7A"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.66929 0C4.59445 0 2.96421 1.63024 2.96421 3.70508C2.96421 5.77993 4.59445 7.41016 6.66929 7.41016C8.74414 7.41016 10.3744 5.77993 10.3744 3.70508C10.3744 1.63024 8.74414 0 6.66929 0ZM6.66915 5.92755C5.40942 5.92755 4.4461 4.96423 4.4461 3.7045C4.4461 2.44478 5.40942 1.48145 6.66915 1.48145C7.92888 1.48145 8.8922 2.44478 8.8922 3.7045C8.8922 4.96423 7.92888 5.92755 6.66915 5.92755Z"
      fill="#546E7A"
    />
  </svg>
);

export default Client;
